import { Component, Injector, OnInit } from '@angular/core';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'app-buying-options',
	templateUrl: './buying-options.component.html',
	styleUrls: ['./buying-options.component.scss'],
})
export class BuyingOptionsComponent extends EventsComponent implements OnInit {
	stepsList = [];
	title: string;
	subtitle: string;
	isCovModFlagOn: boolean = false;

	constructor(injector: Injector) {
		super(injector);
	}

	ngOnInit() {
		this.layoutService.globalAttributes.subscribe((data) => {

			this.isCovModFlagOn = data['covModFlag'];
		});
		this.title = this.control.attributes.title;
		this.subtitle = this.control.attributes.subtitle;
		this.stepsList = this.control.attributes.steps;
	}
}
